"use client";

import { type ReactNode, createContext, useContext, useState } from "react";

interface SearchData {
  value: string;
  isRelated?: boolean;
  cargos?: {
    _id: string;
    name: string;
    alias: string | undefined;
  }[];
}

interface SearchContextProps {
  search: SearchData | undefined;
  setSearch: (search: SearchData | undefined) => void;
}

const SearchContext = createContext<SearchContextProps>({
  search: undefined,
  setSearch: () => null,
});

export function SearchProvider({ children }: { children: ReactNode }) {
  const [search, setSearch] = useState<SearchContextProps["search"]>(undefined);

  return (
    <SearchContext.Provider value={{ search, setSearch }}>
      {children}
    </SearchContext.Provider>
  );
}

export function useSearchContext() {
  const context = useContext(SearchContext);

  if (context === undefined) {
    throw new Error("useSearchContext precisa estar dentro de SearchProvider");
  }

  return useContext(SearchContext);
}
